function insertNumberCartItems(cartItems) {
    $(document).ajaxStop(function () {
        // var atLeastOneItem = cartItems >= 1;
        // if(atLeastOneItem){
        $('.maf-minicart-icon').each(function () {
            // console.log($(this));
            //$(this).addClass('show-icon'); //removing for launch, we will come back to it later
            $(this).find('.minicart-quantity')[0].innerHTML = cartItems;
        });
        // } else{
        // $('.maf-minicart-icon').each(function() {               
        //     //something else;
        //     $(this).find('.minicart-quantity')[0].innerHTML = cartItems;
        // });            
        // }
    });
}

$(document).ready(function () {

 const baseUrl = window.location.origin;

// =======================
// Donation modal GA4 tracking helpers (steps + close)
// =======================
function getDonationModalStep() {
    if ($('.donationConfirmation-Container').length && !$('.donationConfirmation-Container').hasClass('d-none')) return 'confirmation';
    if ($('.dontationPayment-Container').length && !$('.dontationPayment-Container').hasClass('d-none')) return 'payment';
    if ($('.useraddressContainer').length && !$('.useraddressContainer').hasClass('d-none')) return 'address';
    if ($('.userdeatilsContainer').length && !$('.userdeatilsContainer').hasClass('d-none')) return 'details';
    if ($('.donation-amount-container').length && !$('.donation-amount-container').hasClass('d-none')) return 'amount';
    return 'unknown';
}

function donationDlPush(evtName, payload) {
    window.dataLayer = window.dataLayer || [];

    // Ensure we always have a session id before sending any event
    window.__mafDonationSessionId = window.__mafDonationSessionId || (Date.now() + '_' + Math.random().toString(16).slice(2));

    window.dataLayer.push(Object.assign({
        event: evtName,
        donation_only: true,
        donation_flow: 'modal',
        donation_session_id: window.__mafDonationSessionId
    }, payload || {}));
}

function getDonationContextFromUI() {
    // Use the robust selector logic you already built
    var sel = (typeof getSelectionFromInputs === 'function')
        ? getSelectionFromInputs()
        : { freq: 'one_time', amt: '0', pid: 'DONATION' };

    var donationType = (sel && sel.freq === 'monthly') ? 'monthly' : 'one_time';

    // Amount
    var value = Number(String(sel && sel.amt ? sel.amt : '0').replace(/[^\d.]/g, '')) || 0;

    // Item id: prefer actual checked input id, fallback to pid
    var $checked = $('.maf-donation-component input[type="radio"]:checked');
    var itemId = ($checked.length && $checked[0].id) ? $checked[0].id : (sel.pid || 'DONATION');

    var itemName = (donationType === 'monthly' ? 'Monthly' : 'One-Time') + ' Donation';

    return {
        currency: 'USD',
        donation_type: donationType,
        value: value,
        item_id: itemId,
        item_name: itemName
    };
}


// Track step view (one per step per modal open)
var DONATION_STEP_INDEX = {
  amount: 1,
  details: 2,
  address: 3,
  payment: 4,
  confirmation: 5
};

function trackDonationStepView(step) {
    try {
        window.__mafDonationStepViewSent = window.__mafDonationStepViewSent || {};
        window.__mafDonationSessionId = window.__mafDonationSessionId || (Date.now() + '_' + Math.random().toString(16).slice(2));

        var key = window.__mafDonationSessionId + '|' + step;
        if (window.__mafDonationStepViewSent[key]) return;
        window.__mafDonationStepViewSent[key] = true;

        // ALWAYS derive fresh context from UI for step events
        var ctx = getDonationContextFromUI ? getDonationContextFromUI() : (window.__mafDonationContext || {});
        // hard defaults so nothing becomes undefined
        ctx.currency = ctx.currency || 'USD';
        ctx.donation_type = ctx.donation_type || 'one_time';
        ctx.value = Number(ctx.value || 0) || 0;
        ctx.item_id = ctx.item_id || 'DONATION';
        ctx.item_name = ctx.item_name || ((ctx.donation_type === 'monthly' ? 'Monthly' : 'One-Time') + ' Donation');

        // keep it updated for later events (close/purchase)
        window.__mafDonationContext = ctx;

        // Clear previous ecommerce state for GA4-style pushes
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });

        donationDlPush('donation_step_view', {
            donation_step: step,
            donation_step_index: DONATION_STEP_INDEX[step] || 0,
            donation_type: ctx.donation_type,
            value: ctx.value,
            item_id: ctx.item_id,
            item_name: ctx.item_name,
            ecommerce: {
                currency: ctx.currency,
                value: ctx.value,
                items: [{
                    item_id: String(ctx.item_id),
                    item_name: String(ctx.item_name),
                    item_brand: 'MedicAlert',
                    item_category: 'Donation',
                    item_category2: String(ctx.donation_type), // monthly | one_time
                    price: ctx.value,
                    quantity: 1
                }]
            }
        });
    } catch (e) {}
}


// Track close (one per step + reason per modal session)
function trackDonationModalClose(reason) {
    try {
        var step = getDonationModalStep();

        window.__mafDonationCloseSent = window.__mafDonationCloseSent || {};
        window.__mafDonationSessionId = window.__mafDonationSessionId || (Date.now() + '_' + Math.random().toString(16).slice(2));
        var key = window.__mafDonationSessionId + '|' + step + '|' + (reason || 'unknown');
        if (window.__mafDonationCloseSent[key]) return;
        window.__mafDonationCloseSent[key] = true;

        var ctx = window.__mafDonationContext || {};
        donationDlPush('donation_modal_close', {
            donation_step: step,
            close_reason: String(reason || 'unknown'),
            donation_type: ctx.donation_type,
            value: ctx.value,
            item_id: ctx.item_id,
            item_name: ctx.item_name
        });
    } catch (e) {}
}

// Reset session when modal opens so step tracking is per open
function resetDonationModalSession() {
    window.__mafDonationSessionId = (Date.now() + '_' + Math.random().toString(16).slice(2));
    window.__mafDonationStepViewSent = {};
    window.__mafDonationCloseSent = {};
}

function goBack() {
    if (window.history.length > 1) {
            history.back();
            return;
        }
        if (document.referrer) {
            window.location = document.referrer;
            return;
        }
        window.location = "/";
    //  var redirectURL= $('#maf-close-donation').attr('data-page-redirect'); 
    //     window.location.href= redirectURL;
    }
 
    // Auto-open modal when URL has #donatenow
    // if (window.location.hash === "#donatenow") {
    //     showGuestCheckoutModal();
    //     $('#guestCheckoutDonationModal').css('background-color', '#1d3557');
        
    //     const style = document.createElement("style");
    //     style.innerHTML = `
    //     .maf-page>:not(#guestCheckoutDonationModal) {
    //         opacity:0 !important;
    //     }
    //     body>:not(.maf-page) {
    //         opacity:0 !important;
    //     }
    // `;
    //     document.head.appendChild(style);
    // }

    // Auto-open modal when URL has #donatenow (guarded against re-firing)
    if (window.location.hash.indexOf("#donatenow") !== -1 && !window.__donationModalOpened) {
        window.__donationModalOpened = true;

        // Store originating return URL if present
        var hashQuery = window.location.hash.split('?')[1];
        if (hashQuery) {
            var params = new URLSearchParams(hashQuery);
            var returnUrl = params.get('returnUrl');
            if (returnUrl) {
                sessionStorage.setItem('donationReturnUrl', decodeURIComponent(returnUrl));
            }
        }

        // Remove #donatenow from URL without reloading the page
        if (window.history && window.history.replaceState) {
            window.history.replaceState(null, null, window.location.pathname + window.location.search);
        }

        showGuestCheckoutModal();
    }


    // Auto-open modal when URL has #donatenow
    if (window.location.hash === "#donatenow-emails") {
        showGuestCheckoutModal();
    }

    // Updated close button logic
    // $('#maf-close-donation, #maf-close-donation-mobile').on('click', function (e) {
        
    //     // Trackc closes from the X button and label which step they were on.
    //     trackDonationModalClose('x_button');

    //     // Normal close process
    //     hideGuestCheckoutModal();
 
    //     resetForm();
    //     clearFrom();
    //     // If URL has #donatenow → go back instead of closing normally
    //     if (window.location.hash === "#donatenow") {
    //         e.preventDefault();
    //         goBack();
    //         return;
    //     }
 
    //     $('.dontationPayment-Container').addClass('d-none');
    //     $('#donationFormGuestCheckout').removeClass('d-none');
    //     $('.useraddressContainer').addClass('d-none');
    //     $('.donation-amount-container').removeClass('d-none');
    //     $('#blurBackgroundID').addClass('d-none');
    //     $('.userdeatilsContainer').addClass('d-none');
    //     $('.memberIDColumn').addClass('d-none');
    //     $('.useraddressConfirmContainer').addClass('d-none');
    //     $('.donationConfirmation-Container').addClass('d-none');
    // });

    $('#maf-close-donation, #maf-close-donation-mobile').on('click', function (e) {
        trackDonationModalClose('x_button');
        hideGuestCheckoutModal();
        resetForm();
        clearFrom();

        var returnUrl = sessionStorage.getItem('donationReturnUrl');
        if (returnUrl) {
            sessionStorage.removeItem('donationReturnUrl');
            window.location.href = returnUrl;
            return;
        }

        if (window.location.hash.indexOf("#donatenow") !== -1) {
            e.preventDefault();
            goBack();
            return;
        }

        $('.dontationPayment-Container').addClass('d-none');
        $('#donationFormGuestCheckout').removeClass('d-none');
        $('.useraddressContainer').addClass('d-none');
        $('.donation-amount-container').removeClass('d-none');
        $('#blurBackgroundID').addClass('d-none');
        $('.userdeatilsContainer').addClass('d-none');
        $('.memberIDColumn').addClass('d-none');
        $('.useraddressConfirmContainer').addClass('d-none');
        $('.donationConfirmation-Container').addClass('d-none');
    });
 

    // $('#plantoday, #navbarDropdownDonate').on('click', function () {
    //     showGuestCheckoutModal();
    // });

    // Non-store (proxied / WordPress) host -> store origin for that environment
    var DONATION_STORE_ORIGIN_BY_HOST = {
        'medicalert.org':         'https://store.medicalert.org',
        'www.medicalert.org':     'https://store.medicalert.org',
        'staging.medicalert.org': 'https://staging-store.medicalert.org'
    };
    var DONATION_ROUTE_PATH = '/on/demandware.store/Sites-medicalert-Site/default/DonationContent-Donation';

    function getStoreOriginForCurrentHost() {
        return DONATION_STORE_ORIGIN_BY_HOST[window.location.hostname.toLowerCase()] || null;
    }

    function checkIsStoreDomain() {
        // Anything not explicitly listed as non-store is a store domain -> never redirect
        return !getStoreOriginForCurrentHost();
    }

    function handleDonateClick(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        var storeOrigin = getStoreOriginForCurrentHost();

        // Store domain: open the modal right here, no navigation
        if (!storeOrigin) {
            if ($('#guestCheckoutDonationModal').length) {
                showGuestCheckoutModal();
            }
            return;
        }

        // Non-store domain: send the user to the Donation route on the store domain
        var returnUrl = encodeURIComponent(window.location.href);
        window.location.href = storeOrigin + DONATION_ROUTE_PATH + '#donatenow?returnUrl=' + returnUrl;
    }

    $('#plantoday, #navbarDropdownDonate').on('click', function (e) {
        handleDonateClick(e);
    });

    function clearFrom(){
        // Put your real form IDs here
        var $forms = $('#donationFormGuestCheckout, #donationPaymentFormGuestCheckout'); 

        $forms.each(function () {
                // Native reset (goes back to default HTML values)
                if (this.reset) {
                    this.reset();
                }

                // Force clear everything
                $(this)
                    .find('input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="password"], textarea')
                    .val('');

                $(this)
                    .find('input[type="checkbox"], input[type="radio"]')
                    .prop('checked', false);

                $(this)
                    .find('select')
                    .prop('selectedIndex', 0);

                // Optional: remove validation classes if you use them
                $(this)
                    .find('.is-valid, .is-invalid')
                    .removeClass('is-valid is-invalid');
            });

            // ===========================
            // DEFAULT RADIO BUTTONS
            // ===========================
            // One-time 25
            $('#onetime_donation_50').prop('checked', true);

            // Monthly 25
            $('#monthly_donation_15').prop('checked', true);

            resetAddressConfirmationToDefault();


        // Clear all validation errors
        $('.is-invalid, .is-valid').removeClass('is-invalid is-valid');
        $('.error-message').text('').hide();
        $('#onetime_other_input_error, #monthly_other_input_error, #smartyStreetError').addClass('d-none');

    }

    function resetAddressConfirmationToDefault() {
        const $recommendedRadio = $('input[name="address-confirmation"][value="recommended"]');

        // Set default radio
        $recommendedRadio.prop('checked', true).trigger('change');

        // Sync visual selection (if used)
        $('.address-confirmation-box').removeClass('selected');
        $recommendedRadio.closest('.address-confirmation-box').addClass('selected');
    }



    function resetForm(){

        $.ajax({
            url: baseUrl + '/on/demandware.store/Sites-medicalert-Site/default/GuestCheckout-RemoveDonation',
            method: 'GET',
            success: function (response) {
                console.log('Donation removed:', response);
            },
            error: function (xhr, status, error) {
                console.error('Error removing donation:', error);
            }
        });

        // Reset to one-time tab
        $('#pills-home-tab').tab('show');
    }


    // Format number with commas (e.g. 1000 -> 1,000)
    function formatWithCommas(value) {
        if (!value) return "";
        const num = value.replace(/[^\d]/g, ""); // remove non-digits
        return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    //Handle checked attribute on input fields    
    const $donationRadios = $('.donationLebel').find('input.fixed-amount[type="radio"]');

    //Attach a 'change' event handler to the radio group.    
    $donationRadios.on('change', function() {
        const $this = $(this); // The newly checked radio button
        
        // Iterate through all radio buttons in the group
        $donationRadios.each(function() {
            const $radio = $(this);
            // Check if the current radio is the one that triggered the change
            if ($radio.is($this)) {
                // This is the selected one, skip for now.
                return;
            }
            
            // Remove the attribute from all others to ensure the DOM is clean
            if ($radio.attr('checked')) {
                 $radio.removeAttr('checked');
            }
        });
        
        // Add the 'checked' attribute to the element that was just selected/changed.
        $this.attr('checked', true);

        console.log("Donation amount changed to: " + $this.val());
        console.log("DOM 'checked' attribute successfully updated.");
    });
    
    
    // Initial check (optional, but good practice):
    // Ensure the default selected item has the 'checked' attribute on load.
    // This addresses the scenario where the initial state might be missing the attribute.
    if ($donationRadios.filter(':checked').length === 0) {
        // If nothing is checked initially, check the first one as default
        $donationRadios.first().attr('checked', true);
    }


    // --- One-time custom amount ---
    $("#onetime_other_input").on("input", function () {
        let val = $(this).val().replace(/,/g, "");
        // Uncheck all fixed radios
        $("input.fixed-amount-onetime").prop("checked", false);
        // Check "other" radio
        $("#onetime_other_radio").prop("checked", true);
        // Format with commas
        $(this).val(formatWithCommas(val));
    });

    // --- Monthly custom amount ---
    $("#monthly_other_input").on("input", function () {
        let val = $(this).val().replace(/,/g, "");
        $("input.fixed-amount-monthly").prop("checked", false);
        $("#monthly_other_radio").prop("checked", true);
        $(this).val(formatWithCommas(val));
    });

    /** ---------- UNCHECK OTHER WHEN FIXED AMOUNT SELECTED ---------- **/

    $("input.fixed-amount-onetime").on("change", function () {
        $("#onetime_other_input").val("");
        $("#onetime_other_radio").prop("checked", false);
    });

    $("input.fixed-amount-monthly").on("change", function () {
        $("#monthly_other_input").val("");
        $("#monthly_other_radio").prop("checked", false);
    });


    let isDropdownOpen = false;
    $('#navbarDropdownDonateMobile').on('pointerdown', function (e) {
        if (e.pointerType === "touch") {
            if (isDropdownOpen) {
                e.preventDefault();
                e.stopPropagation();
                $(this).dropdown('hide');
                isDropdownOpen = false;

                handleDonateClick(e);
            } else {
                isDropdownOpen = true;
            }
        } else {
            handleDonateClick(e);
        }
    });
    $('#navbarDropdownDonateMobile').on('hide.bs.dropdown', function () {
        isDropdownOpen = false;
    });
    $('#navbarDropdownDonateMobile').on('show.bs.dropdown', function () {
        isDropdownOpen = true;
    });
    $('#plantodayMobile').on('click', function (e) {
        isDropdownOpen = false;
        handleDonateClick(e);
    });

    //  // Trigger modal if URL has #donatenow
    // if (window.location.hash === "#donatenow") {
    //     showGuestCheckoutModal();

    //     $('#guestCheckoutDonationModal').css('background-color','#1d3557');

    //     // // When modal is closed, go back
    //     // $('#guestCheckoutDonationModal').on("hidden.bs.modal", function () {
    //     //     goBack();
    //     // });
    // }

    // Add click listeners to donation triggers
    $('a[modal-trigger="donation"], button[modal-trigger="donation"],body#pendo-button-c5b9f7d8').on("click", function (e) {
        e.preventDefault();
        showGuestCheckoutModal();
    });         

    function pendoModalTriger() {
        // We use 'body' as the stable, always-present ancestor for event delegation
        $('body').on("click", '#pendo-button-c5b9f7d8', function (e) {
            // Prevent Pendo's default action (if any)
            e.preventDefault();

            console.log('Pendo click (Delegated)');

            // Call the SFCC modal function
            if (typeof showGuestCheckoutModal === 'function') {
                showGuestCheckoutModal();
            } else {
                console.error('Error: showGuestCheckoutModal is not defined in the current scope.');
            }
        });
    }
    pendoModalTriger(); 

    $('#info-1').on('mouseenter focusin', function () {
        $('#g-donationtootip-1').removeClass('d-none');
    });

    $('#info-1').on('mouseleave focusout', function () {
        $('#g-donationtootip-1').addClass('d-none');
    });

    $('#info-2').on('mouseenter focusin', function () {
        $('#g-donationtootip-2').removeClass('d-none');
    });

    $('#info-2').on('mouseleave focusout', function () {
        $('#g-donationtootip-2').addClass('d-none');
    });


    $('.update-donation').on('click', function () {
        const $btn = $(this);
        const origText = $btn.text();
        const loaderURL = $('#loaderImage').val();

        // Verification of donation input
        let sel = getSelectionFromInputs();
        // what amount is present
        if (!sel.amt || parseFloat(sel.amt) === 0) {
            if (sel.freq === "monthly") {
                $('#monthly_other_input_error').removeClass('d-none');
                $('#onetime_other_input_error').addClass('d-none');
            } else {
                $('#onetime_other_input_error').removeClass('d-none');
                $('#monthly_other_input_error').addClass('d-none');
            }
            return;
        }
        // if amount is valid, both errors dnone
        $('#onetime_other_input_error').addClass('d-none');
        $('#monthly_other_input_error').addClass('d-none');

        $btn.prop('disabled', true).html(`
        <span class="loaderForWizard">
            <img class="loaderForWizardImage" src="${loaderURL}" alt="credit-card-image" />
        </span>
        `);
        var url = baseUrl + "/on/demandware.store/Sites-medicalert-Site/default/GuestCheckout-GetDonationForm"
        $.ajax({
            url: url,
            type: 'GET',
            success: function (data) {
                if(data.loggedIn && data.customerAddress){
                    $('#donationFormGuestCheckout #billingFirstNameGuest').val(data?.customerProfile?.firstName);
                    $('#donationFormGuestCheckout #billingLastNameGuest').val(data?.customerProfile?.lastName);
                    $('#donationFormGuestCheckout #billingPhoneGuest').val(data?.customerAddress?.phone);
                    $('#donationFormGuestCheckout #billingEmail').val(data?.customerProfile?.email);
                    $('#donationFormGuestCheckout #billingAddressGuest').val(data?.customerAddress?.address1);
                    $('#donationFormGuestCheckout #billingAptGuest').val(data?.customerAddress?.address2);
                    $('#donationFormGuestCheckout #billingCityGuest').val(data?.customerAddress?.city);
                    $('#donationFormGuestCheckout #billingStateGuest').val(data?.customerAddress?.stateCode);
                    $('#donationFormGuestCheckout #billingZipGuest').val(data?.customerAddress?.postalCode);
                    $('#donationFormGuestCheckout .checkboxContainer').addClass('d-none');
                   }    
                    $('.donation-amount-container').addClass('d-none');
                    $('#blurBackgroundID').removeClass('d-none');
                    $('.userdeatilsContainer').removeClass('d-none');
                    // Analytics - Step = details (user clicked Continue from amount step)
                    trackDonationStepView('details');
                    $btn.prop('disabled', false).text(origText);
                },
            error: function (xhr, status, error) {
                $btn.prop('disabled', false).text(origText);
                $('.donation-amount-container').addClass('d-none');
                $('#blurBackgroundID').removeClass('d-none');
                $('.userdeatilsContainer').removeClass('d-none');
                console.error('Error loading doantion modal:', error);
            }
        });   
    });  

    // Clear errors when user selects any fixed amount radio buttons
    $('.fixed-amount-onetime, .fixed-amount-monthly').on('change', function() {
        $('#onetime_other_input_error').addClass('d-none');
        $('#monthly_other_input_error').addClass('d-none');
    });

    // Clear errors when user types in custom amount inputs
    $('#onetime_other_input, #monthly_other_input').on('input', function() {
        $('#onetime_other_input_error').addClass('d-none');
        $('#monthly_other_input_error').addClass('d-none');
    });

    $('#arrow-left').on('click', function () {
        $('.donation-amount-container').removeClass('d-none');
        $('#blurBackgroundID').addClass('d-none');
        $('.userdeatilsContainer').addClass('d-none');
        const fields = [
            [$first, rules.firstName],
            [$last, rules.lastName],
            [$email, rules.email],
            [$phone, rules.phone],
            [$memberId, Object.assign({}, rules.memberId, { required: $memberCk.is(":checked") })]
        ];
        fields.forEach(([el, r]) => { el.removeClass("is-invalid is-valid"); ensureErrorSlot(el).hide(); });
    });

    $('#arrow-left-03').on('click', function () {
        $('.dontationPayment-Container').addClass('d-none');
        $('#donationFormGuestCheckout').removeClass('d-none');
        $('.useraddressContainer').removeClass('d-none');
        resetAddressConfirmationToDefault();

        const $cardNumber = $("#Order-CardNumber-guestCheckout");
        const $cardType = $("#cardType-guestCheckout"); // hidden input
        const $exp = $("#Order-expdate-GuestCheckout");
        const $cvv = $("#Order-cvv-GuestCheckout");
        const cardFields = [
            [$cardNumber, null],
            [$cardType, null],
            [$exp, null],
            [$cvv, null]]

        cardFields.forEach(([el, r]) => { el.removeClass("is-invalid is-valid"); ensureErrorSlot(el).hide(); });
    });


    $("#arrow-left-04").on('click', function () {
        $(".useraddressContainer").removeClass("d-none");
        $(".useraddressConfirmContainer").addClass("d-none");
    });

    $('#blurBackgroundID').on('mouseenter', function () {
        $(this).addClass('d-none');
    });

    $('.banner-image-container').on('mouseleave', function () {
        if ($('.donation-amount-container').hasClass('d-none')) {
            $('#blurBackgroundID').removeClass('d-none');
        }
    });

    $('#arrow-left-02').on('click', function () {
        $('.userdeatilsContainer').removeClass('d-none');
        $('.useraddressContainer').addClass('d-none');
        const addressFields = [
            [$addr, rules.addressLine],
            [$city, rules.city],
            [$state, rules.state],
            [$zip, rules.zip],
            [$country, rules.country]
        ];
        addressFields.forEach(([el, r]) => { el.removeClass("is-invalid is-valid"); ensureErrorSlot(el).hide(); });
    });

    // ========== 1️⃣ Utility: error UI handling ==========
    function ensureErrorSlot($input, explicitSelector) {
        if (explicitSelector && $(explicitSelector).length) return $(explicitSelector);
        let $slot = $input.siblings(".error-message");
        if (!$slot.length) $slot = $('<span class="error-message" aria-live="polite"></span>').insertAfter($input);
        return $slot;
    }

    function markValid($input) {
        $input.removeClass("is-invalid").addClass("is-valid").removeAttr("aria-invalid");
        ensureErrorSlot($input).text("").hide();
    }

    function markInvalid($input, msg, explicitSelector) {
        const $slot = ensureErrorSlot($input, explicitSelector);
        $slot.text(msg).show();
        $input.removeClass("is-valid").addClass("is-invalid").attr("aria-invalid", "true");
    }

    // ========== 2️⃣ Core: generic validation engine ==========
    function validateField($input, rule) {
        if (!rule) {
            // defensive: if rule not provided, mark input valid and return
            $input.removeClass("is-invalid").addClass("is-valid");
            ensureErrorSlot($input).text("").hide();
            return { ok: true, cleaned: ($input.val() || "").toString().trim() };
        }

        const explicitSelector = rule.explicitSelector;
        let raw = ($input.val() || "").toString();

        // optional live formatting (e.g., phone or zip)
        if (typeof rule.formatter === "function") {
            const formatted = rule.formatter(raw);
            if (formatted !== raw) $input.val(formatted);
            raw = formatted;
        }

        const cleaned = typeof rule.clean === "function" ? rule.clean(raw) : raw.trim();

        // required check
        if (rule.required && (!cleaned || cleaned.length === 0)) {
            markInvalid($input, rule.requiredMsg || "This field is required.", explicitSelector);
            return { ok: false, cleaned };
        }

        // optional and empty → clear state
        if (!cleaned && !rule.required) {
            $input.removeClass("is-invalid is-valid");
            ensureErrorSlot($input, explicitSelector).hide();
            return { ok: true, cleaned };
        }

        // apply regex or custom test
        if (rule.regex && !rule.regex.test(cleaned)) {
            markInvalid($input, rule.msg || "Invalid value", explicitSelector);
            return { ok: false, cleaned };
        }
        if (rule.test && typeof rule.test === "function") {
            const res = rule.test(cleaned);
            if (!res.ok) {
                markInvalid($input, res.msg || "Invalid value", explicitSelector);
                return { ok: false, cleaned };
            }
        }

        markValid($input);
        return { ok: true, cleaned };
    }

    // ========== 3️⃣ Common helpers ==========
    const digitsOnly = s => (s || "").replace(/\D/g, "");
    const formatUSPhone = v => {
        const d = digitsOnly(v).slice(0, 10);
        if (d.length <= 3) return d;
        if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
        return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
    };

    // ========== 4️⃣ Validation rules ==========
    const rules = {
        // shared name rule used by first and last
        name: { required: true, regex: /^[\p{L}\s'.-]{1,50}$/u, msg: "Only letters, spaces, or punctuation allowed (max 50)." },

        email: { required: true, regex: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, msg: "Enter a valid email address.", explicitSelector: "#billingEmailError" },

        phone: {
            required: false,
            formatter: formatUSPhone,
            clean: v => digitsOnly(v),
            test: v => (!v || v.length === 10 ? { ok: true } : { ok: false, msg: "Enter 10 digits." }),
            explicitSelector: "#billingPhoneError"
        },

        memberId: { required: false, regex: /^[A-Za-z0-9-]{1,11}$/, msg: "Up to 11 letters or numbers.", explicitSelector: "#MemberIDError" },

        address: { required: true, test: v => (v.length <= 50 ? { ok: true } : { ok: false, msg: "Max 50 characters." }), explicitSelector: "#billingAddressError" },

        city: { required: true, regex: /^[\p{L}\s'.-]{1,50}$/u, msg: "Letters and spaces only." },

        state: { required: true, requiredMsg: "Select a state.", explicitSelector: "#billingStateError" },

        zip: {
            required: true,
            formatter: v => digitsOnly(v).slice(0, 5),
            test: v => (/^\d{5}$/).test(v) ? { ok: true } : { ok: false, msg: "Enter 5 digits." },
            explicitSelector: "#billingZipError"
        },

        country: { required: true, requiredMsg: "Country is required.", explicitSelector: "#billingCountryError" }
    };

    // === Aliases (so handlers can use descriptive keys) ===
    // firstName/lastName map to name rule; addressLine maps to address rule
    rules.firstName = Object.assign({}, rules.name);
    rules.lastName = Object.assign({}, rules.name);
    rules.addressLine = Object.assign({}, rules.address);

    // ========== 5️⃣ Cache DOM elements ==========
    const $first = $("#billingFirstNameGuest"), $last = $("#billingLastNameGuest"), $email = $("#billingEmail"), $phone = $("#billingPhoneGuest");
    const $memberCk = $("#memberIdCheckbox"), $memberId = $("#billing-MemberID");
    const $addr = $("#billingAddressGuest"), $apt = $("#billingAptGuest"), $city = $("#billingCityGuest"), $state = $("#billingStateGuest"), $zip = $("#billingZipGuest"), $country = $("#billingCountryGuest");

    // ========== 6️⃣ Live validation: user details ==========
    $first.on("input blur", () => validateField($first, rules.firstName));
    $last.on("input blur", () => validateField($last, rules.lastName));
    $email.on("input blur", () => validateField($email, rules.email));
    // phone: run formatter on input and validate on blur
    $phone.on("input", () => validateField($phone, rules.phone));
    $phone.on("blur", () => validateField($phone, rules.phone));

    $memberCk.on("change", function () {
        const required = $(this).is(":checked");
        $(".memberIDColumn").toggleClass("d-none", !required);
        const memberRule = Object.assign({}, rules.memberId, { required });
        validateField($memberId, memberRule);
        $memberId.removeClass("is-invalid is-valid"); ensureErrorSlot($memberId).hide();
    });
    $memberId.on("input blur", () => {
        const memberRule = Object.assign({}, rules.memberId, { required: $memberCk.is(":checked") });
        validateField($memberId, memberRule);
    });

    // ========== 7️⃣ User Details → Address ==========
    $("#donationContinueBtn").on("click", function (e) {
        e.preventDefault();

        const fields = [
            [$first, rules.firstName],
            [$last, rules.lastName],
            [$email, rules.email],
            [$phone, rules.phone],
            [$memberId, Object.assign({}, rules.memberId, { required: $memberCk.is(":checked") })]
        ];

        let allOk = true;
        // Validate every field (no short-circuit), mark errors as needed
        fields.forEach(([el, r]) => {
            const res = validateField(el, r);
            if (!res.ok) allOk = false;
        });

        if (!allOk) {
            // focus first invalid AFTER marking all errors
            const $firstInvalid = $(".is-invalid").first();
            if ($firstInvalid.length) $firstInvalid.focus();
            return;
        }

        // all good -> show address section
        $(".userdeatilsContainer").addClass("d-none");
        $(".useraddressContainer").removeClass("d-none");
        // Analytics - Step = address
        trackDonationStepView('address');
        $("#billingAddressGuest").focus();
    });

    // ========== 8️⃣ Address validation ==========
    $addr.on("input blur", () => validateField($addr, rules.addressLine));
    $city.on("input blur", () => validateField($city, rules.city));
    $state.on("change blur", () => validateField($state, rules.state));
    // zip: format on input, validate on blur
    $zip.on("input", function () {
        const cleaned = (this.value || "").replace(/\D/g, "").slice(0, 5);
        if (this.value !== cleaned) this.value = cleaned;
        // clear while typing
        ensureErrorSlot($zip).text("").hide();
        $zip.removeClass("is-invalid");
    });
    $zip.on("blur", () => validateField($zip, rules.zip));
    $country.on("change blur", () => validateField($country, rules.country));



    $form = $("#donationFormGuestCheckout");
    // ---------- helper: determine active pane id ----------
    function activePaneId() {
        // 1) Prefer the active nav link (most robust when Bootstrap hasn't toggled pane classes yet)
        const $activeNav = $('#pills-tab .nav-link.active');
        if ($activeNav.length) {
            // data-target is preferred, but fall back to href or aria-controls
            let target = $activeNav.attr('data-target') || $activeNav.data('target') || $activeNav.attr('href') || $activeNav.attr('aria-controls');
            if (target) {
                // target might be "#pills-profile" or "pills-profile"
                target = String(target).trim();
                return target.replace(/^#/, '');
            }
        }

        // 2) Next prefer a pane with the .active class
        const $paneActive = $('.tab-content .tab-pane.active');
        if ($paneActive.length) return $paneActive.first().attr('id');

        // 3) Next prefer the visible pane (works if Bootstrap hides/shows by display)
        const $visible = $('.tab-content .tab-pane').filter(function () { return $(this).is(':visible'); });
        if ($visible.length) return $visible.first().attr('id');

        // 4) Fallback
        return 'pills-home';
    }

    // ---------- deterministic selection: prefer checked inside active pane, fallback otherwise ----------
    function getSelectionFromInputs() {
        const pane = activePaneId();

        // helper to sanitize value
        const cleanVal = v => (String(v || "").replace(/,/g, "").trim());

        // 1) Try fixed radio in active pane
        if (pane === "pills-profile") {
            const $fixed = $('#pills-profile').find('input[name="amt_monthly"]:checked');
            if ($fixed.length && $fixed.val()) return { freq: "monthly", amt: cleanVal($fixed.val()), pid: $('#pills-profile').find('input[name="pid-monthly"]').val() || "90001" };
            // try monthly custom radio in active pane
            if ($('#monthly_other_radio').is(':checked')) return { freq: "monthly", amt: cleanVal($('#monthly_other_input').val()), pid: $('#pills-profile').find('input[name="pid-monthly"]').val() || "90001" };
        } else {
            const $fixed = $('#pills-home').find('input[name="amt_onetime"]:checked');
            if ($fixed.length && $fixed.val()) return { freq: "one_time", amt: cleanVal($fixed.val()), pid: $('#pills-home').find('input[name="pid-oneTime"]').val() || "90000A" };
            if ($('#onetime_other_radio').is(':checked')) return { freq: "one_time", amt: cleanVal($('#onetime_other_input').val()), pid: $('#pills-home').find('input[name="pid-oneTime"]').val() || "90000A" };
        }

        // 2) If nothing in active pane, fallback to checked anywhere (monthly first)
        const $monthlyChecked = $('#pills-profile').find('input[name="amt_monthly"]:checked');
        if ($monthlyChecked.length && $monthlyChecked.val()) return { freq: "monthly", amt: cleanVal($monthlyChecked.val()), pid: $('#pills-profile').find('input[name="pid-monthly"]').val() || "90001" };
        const $oneChecked = $('#pills-home').find('input[name="amt_onetime"]:checked');
        if ($oneChecked.length && $oneChecked.val()) return { freq: "one_time", amt: cleanVal($oneChecked.val()), pid: $('#pills-home').find('input[name="pid-oneTime"]').val() || "90000A" };

        // 3) check custom radios anywhere
        if ($('#monthly_other_radio').is(':checked')) return { freq: "monthly", amt: cleanVal($('#monthly_other_input').val()), pid: $('#pills-profile').find('input[name="pid-monthly"]').val() || "90001" };
        if ($('#onetime_other_radio').is(':checked')) return { freq: "one_time", amt: cleanVal($('#onetime_other_input').val()), pid: $('#pills-home').find('input[name="pid-oneTime"]').val() || "90000A" };

        // 4) last resort: any checked radio anywhere
        const $anyChecked = $('input[type="radio"]:checked').filter(function () { return $(this).val(); });
        if ($anyChecked.length) {
            const $first = $anyChecked.first();
            const nm = ($first.attr('name') || "").toLowerCase();
            const v = cleanVal($first.val());
            if (nm.indexOf('monthly') !== -1) return { freq: "monthly", amt: v, pid: $('#pills-profile').find('input[name="pid-monthly"]').val() || "90001" };
            return { freq: "one_time", amt: v, pid: $('#pills-home').find('input[name="pid-oneTime"]').val() || "90000A" };
        }

        return { freq: null, amt: "", pid: null };
    }


    //SmartyStreet Address
    var $formParent = $("#donationFormGuestCheckout");
    var smartymaxresults = $formParent.find(".smartymaxresults").data("smartymaxresults");
    var smartyembeddedkey = $formParent.find(".smartyembeddedkey").data("smartyembeddedkey");
    var smartyurl = $formParent.find(".smartyurl").data("smartyurl");
    var $addressSuggestionsContainerBilling = $formParent.find(".us-autocomplete-pro-menu-billing-guest");
    var $addressFieldBilling = $(".js-smartystreet-address-field-billing-guest");

    function debounce(func, delay) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    }

    var $billingAddress2Field = $formParent.find("#billingAptGuest");
    var $billingCityField = $formParent.find("#billingCityGuest");
    var $billingStateField = $formParent.find("#billingStateGuest");
    var $billingZipField = $formParent.find("#billingZipGuest");

    $("#billingAddressGuest")
        .on(
            "input",
            debounce(function () {
                var billingAddressValue = $(this).val();
                if (!billingAddressValue) {
                    $addressSuggestionsContainerBilling.addClass("d-none");
                    return;
                }

                $.ajax({
                    url: smartyurl + smartyembeddedkey,
                    method: "GET",
                    data: {
                        search: billingAddressValue,
                        max_results: smartymaxresults,
                    },
                    success: function (data) {
                        if (!data.suggestions || $addressFieldBilling.val() === "") {
                            $addressSuggestionsContainerBilling.addClass("d-none");
                            return;
                        }

                        var billingHtmlString = "";
                        data.suggestions.forEach(function (suggestion) {
                            billingHtmlString += `
            <div class="suggested-billing-address-line">
            <span class="billingAdd1">${suggestion.street_line}</span>,
            ${suggestion.secondary !== ""
                                    ? '<span class="billingApt">' + suggestion.secondary + "</span>, "
                                    : ""
                                }
            <span class="billingCity">${suggestion.city}</span>,
            <span class="billingState">${suggestion.state}</span>
            <span class="billingZip">${suggestion.zipcode}</span>
            </div>`;
                        });

                        $addressSuggestionsContainerBilling
                            .removeClass("d-none")
                            .html(billingHtmlString);
                    },
                    error: function (xhr, status, error) {
                        console.error("Error calling SmartyStreets API:", error);
                        $("#billingAddressError").text("Error fetching address suggestions.");
                    },
                });
            }, 200)
        )
        .on("focusout", function () {
            setTimeout(() => {
                $addressSuggestionsContainerBilling.addClass("d-none");
            }, 200);
        });

    $addressSuggestionsContainerBilling.on(
        "click",
        ".suggested-billing-address-line",
        function () {
            var $billingSel = $(this);

            // Populate each field
            $addressFieldBilling.val($billingSel.find(".billingAdd1").text());
            $billingAddress2Field.val($billingSel.find(".billingApt").text() || "");
            $billingCityField.val($billingSel.find(".billingCity").text());
            $billingStateField.val($billingSel.find(".billingState").text());
            $billingZipField.val($billingSel.find(".billingZip").text());

            // Trigger field updates
            if ($billingAddress2Field.val()) $billingAddress2Field.trigger("blur");
            $billingCityField.trigger("blur");
            $billingStateField.trigger("blur");
            $billingZipField.trigger("blur");

            // Hide validation errors
            $("#billingCityError, #billingStateError, #billingZipError").hide();

            // Save the full address JSON
            var billingAddress = {
                address1: $billingSel.find(".billingAdd1").text().trim() || "",
                address2: $billingSel.find(".billingApt").text().trim() || "",
                city: $billingSel.find(".billingCity").text().trim() || "",
                state: $billingSel.find(".billingState").text().trim() || "",
                postalCode: $billingSel.find(".billingZip").text().trim() || "",
            };
            $("#selectedSmartyBillingAddressID").val(JSON.stringify(billingAddress));

            // Mark field and hide suggestion box
            document.getElementById("billingStateGuest").classList.add("clicked");
            $addressSuggestionsContainerBilling.addClass("d-none");
        }
    )


    var userEnteredAddressData = null;
    var recommendedAddressData = null;

    function showAddressConfirmationUI() {
        // Recommended
        $(".recommended-address-line1").text(recommendedAddressData?.address1);
        $(".r-City").text(recommendedAddressData?.city);
        $(".r-State").text(recommendedAddressData?.state);
        $(".r-Zip").text(recommendedAddressData?.postalCode);

        // Entered
        $(".entered-address-line1").text(userEnteredAddressData?.address1);
        $(".e-City").text(userEnteredAddressData?.city);
        $(".e-State").text(userEnteredAddressData?.state);
        $(".e-Zip").text(userEnteredAddressData?.postalCode);
        $(".useraddressContainer").addClass("d-none");
        $(".useraddressConfirmContainer").removeClass("d-none");
        const $btn = $("#user-address-update");
        $btn.html('')
        $btn.prop("disabled", false).text("Continue");
    }



    // SmartyStreet Address Verification
    async function GetSmartyAddress() {
        return new Promise((resolve) => {
            var addressValue = $("#billingAddressGuest").val().trim();
            var exactAddress = addressValue;

            $.ajax({
                url: smartyurl + smartyembeddedkey,
                method: "GET",
                data: {
                    search: exactAddress,
                    max_results: smartymaxresults,
                },
                success: function (data) {

                    if (!data.suggestions || data.suggestions.length === 0) {
                        showAddressError();
                        resolve(false);
                        return;
                    }

                    // User-entered address
                    userEnteredAddressData = {
                        address1: $("#billingAddressGuest").val().trim(),
                        city: $("#billingCityGuest").val().trim(),
                        state: $("#billingStateGuest").val().trim(),
                        postalCode: $("#billingZipGuest").val().trim(),
                    };

                    var suggestions = data.suggestions || [];

                    var isMatch = suggestions.some(function (s) {
                        return (
                            (s.street_line || "").trim() === userEnteredAddressData?.address1 &&
                            (s.city || "").trim() === userEnteredAddressData?.city &&
                            (s.state || "").trim() === userEnteredAddressData?.state &&
                            (s.zipcode || "").trim() === userEnteredAddressData?.postalCode
                        );
                    });

                    if (isMatch) {
                        recommendedAddressData = userEnteredAddressData;
                        resolve(true);
                    } else {
                        // Take FIRST suggestion as recommended
                        var s = suggestions[0];

                        recommendedAddressData = {
                            address1: (s.street_line || "").trim(),
                            city: (s.city || "").trim(),
                            state: (s.state || "").trim(),
                            postalCode: (s.zipcode || "").trim(),
                        };

                        showAddressConfirmationUI();
                        resolve(false);
                    }
                },
                error: function () {
                    showAddressError();
                    resolve(false);
                }
            });
        });
    }



    function showAddressError() {
        if (!!$('#billingAptGuest').val()) {
            $('#billingAptGuest').addClass("is-invalid");
        }
        $("#billingAddressGuest, #billingCityGuest, #billingStateGuest, #billingZipGuest, #billingCountryGuest").addClass("is-invalid");
        $("#smartyStreetError").text("Please check your address, as we could not verify its accuracy.").show();
    }

    // Submit (Continue Btn)
    // $("#user-address-update").on("click", function (e) {
    //     e.preventDefault();

    //     GetSmartyAddress();
    // });

    $("#billingAddressGuest, #billingAptGuest, #billingCityGuest, #billingStateGuest, #billingZipGuest, #billingCountryGuest")
        .on("input", function () {
            $("#billingAddressGuest, #billingAptGuest, #billingCityGuest, #billingStateGuest, #billingZipGuest, #billingCountryGuest").removeClass("is-invalid");
            $("#smartyStreetError").hide();
        });


    function applyAddressToForm(address) {
        $("#billingAddressGuest").val(address?.address1 || "");
        $("#billingCityGuest").val(address?.city || "");
        $("#billingStateGuest").val(address?.state || "");
        $("#billingZipGuest").val(address?.postalCode || "");
    }    


    $("#user-address-update").on("click", async function (e) {
         e.preventDefault();
        const $btn = $("#user-address-update");
        const loaderURL = $('#loaderImage').val();

        $btn.prop('disabled', true).html(`
        <span class="loaderForWizard">
            <img class="loaderForWizardImage" src="${loaderURL}" alt="credit-card-image" />
        </span>
        `);
        try{
        const isValid = await GetSmartyAddress();

        if (isValid === true) {
            // Address is clean → allow user to proceed
            $("#address-confirmation-continue").trigger("click");
        }
    }
    finally {
    $btn.prop("disabled", false).text("Continue");
    }
    });

    $(".address-confirmation-box").on("click", function (e) {
        // Prevent double-trigger when clicking directly on radio
        if (!$(e.target).is('input[type="radio"]')) {
            $(this).find('input[type="radio"]').prop("checked", true).trigger("change");
        }
    });

    $(".address-confirmation-box").on("click", function () {
        $(".address-confirmation-box").removeClass("selected");
        $(this).addClass("selected");
    });


    // ========== Address Continue (minimal, only sends amt + pid) ==========
    $("#address-confirmation-continue").on("click", async function (e) {
        e.preventDefault();
        const $btn = $(this);

        var selected = $("input[name='address-confirmation']:checked").val();
        if (selected === "recommended") {
            applyAddressToForm(recommendedAddressData);
        } else {
            applyAddressToForm(userEnteredAddressData);
        }
        // 1) Validate address fields (reuse your validateField/rules)
        const addressFields = [
            [$addr, rules.addressLine],
            [$city, rules.city],
            [$state, rules.state],
            [$zip, rules.zip],
            [$country, rules.country]
        ];
        let allOk = true;
        addressFields.forEach(([el, r]) => { if (!validateField(el, r).ok) allOk = false; });
        if ($apt.val().trim()) $apt.removeClass("is-invalid").addClass("is-valid"); else $apt.removeClass("is-invalid is-valid");
        if (!allOk) { const $firstInvalid = $(".is-invalid").first(); if ($firstInvalid.length) $firstInvalid.focus(); return; }

        // 2) Determine selection robustly (prefer visible pane)
        function visiblePaneId() {
            // prefer visible pane over relying on .active
            const $vis = $(".tab-content .tab-pane").filter(function () { return $(this).is(":visible"); });
            return $vis.first().attr("id") || $(".tab-content .tab-pane.active").attr("id") || "pills-home";
        }
        const pane = visiblePaneId();
        const cleanVal = v => String((v || "")).replace(/,/g, "").trim();

        let sel = getSelectionFromInputs();

        if (!sel.amt) {
            const $monthlyChecked = $('#pills-profile').find('input[name="amt_monthly"]:checked');
            if ($monthlyChecked.length && $monthlyChecked.val()) sel = { freq: "monthly", amt: cleanVal($monthlyChecked.val()), pid: $('#pills-profile').find('input[name="pid-monthly"]').val() || "90001" };
            else {
                const $oneChecked = $('#pills-home').find('input[name="amt_onetime"]:checked');
                if ($oneChecked.length && $oneChecked.val()) sel = { freq: "one_time", amt: cleanVal($oneChecked.val()), pid: $('#pills-home').find('input[name="pid-oneTime"]').val() || "90000A" };
            }
        }

        // last fallback: custom radios anywhere
        if (!sel.amt) {
            if ($('#monthly_other_radio').is(':checked')) sel = { freq: "monthly", amt: cleanVal($('#monthly_other_input').val()), pid: $('#pills-profile').find('input[name="pid-monthly"]').val() || "90001" };
            else if ($('#onetime_other_radio').is(':checked')) sel = { freq: "one_time", amt: cleanVal($('#onetime_other_input').val()), pid: $('#pills-home').find('input[name="pid-oneTime"]').val() || "90000A" };
        }

        // 3) require amount
        // if (!sel.amt) {
        //     alert("Please choose or enter a donation amount.");
        //     return;
        // }

        // 4) Create canonical hidden fields (data-canonical marks them) if missing, and set values
        function ensureCanonical(name, value) {
            let $el = $form.find('input[name="' + name + '"][data-canonical="true"]');
            if (!$el.length) {
                $form.append('<input type="hidden" name="' + name + '" data-canonical="true" value="">');
                $el = $form.find('input[name="' + name + '"][data-canonical="true"]');
            }
            if (typeof value !== "undefined") $el.val(value);
            return $el;
        }
        ensureCanonical("amt", sel.amt);
        ensureCanonical("pid", sel.pid);
        ensureCanonical("billingPhoneClean", ($("#billingPhoneGuest").val() || "").replace(/\D/g, ""));

        // 5) Remove names from donation-pane inputs (so serialization only includes canonical fields)
        const removed = [];
        $form.find(".donation-amount-container").find("input[name],select[name],textarea[name]").each(function () {
            const nm = this.getAttribute("name");
            if (!nm) return;
            // skip canonical if present inside donation area (we marked them data-canonical) — safety check
            if (this.getAttribute("data-canonical") === "true") return;
            removed.push({ el: this, name: nm });
            this.removeAttribute("name");
        });

            // helper to restore names
            function restoreRemovedNames() {
                removed.forEach(function (item) {
                    if (item && item.el && item.name) {
                        item.el.setAttribute("name", item.name);
                    }
                });
                removed.length = 0;
            }


        // 6) Serialize and send
        const data = $form.serialize();

        const endpoint = baseUrl + "/on/demandware.store/Sites-medicalert-Site/default/GuestCheckout-AddToCartDonation";

        const origText = $btn.text();
        const loaderURL = $('#loaderImage').val();

        $btn.prop('disabled', true).html(`
        <span class="loaderForWizard">
            <img class="loaderForWizardImage" src="${loaderURL}" alt="credit-card-image" />
        </span>
        `);


        $.ajax({
            url: endpoint,
            method: "POST",
            data: data,
            dataType: "json",
            success: function (resp) {
                restoreRemovedNames();
                if (resp && resp.redirectUrl) { window.location.href = resp.redirectUrl; return; }
                if (resp && (resp.success || resp.ok)) {
                    if (resp.message) alert(resp.message);
                    else {
                        $('#donationPid').val(resp.pid);
                        $('#donationAmt').val(resp.subTotals);

                        // --- [START] GA4 Donation: add_to_cart + begin_checkout (only after SFCC confirms add-to-cart) ---
                        try {
                            // donation type based on selection you already computed
                            var donationType = (sel && sel.freq === 'monthly') ? 'monthly' : 'one_time';

                            // use your chosen amount
                            var donationValue = Number(String(sel && sel.amt ? sel.amt : '0').replace(/[^\d.]/g, ''));

                            // grab the checked radio's id so it matches your view_item logic
                            var $checked = $('.maf-donation-component #pills-tabContent .tab-pane.active.show input:checked');
                            var itemId = ($checked.length && $checked[0].id) ? $checked[0].id : (resp.pid || 'DONATION');

                            var itemName = (donationType === 'monthly' ? 'Monthly' : 'One-Time') + ' Donation';

                            // store context for later purchase call
                            window.__mafDonationContext = {
                                currency: 'USD',
                                donation_type: donationType,
                                value: donationValue,
                                item_id: itemId,
                                item_name: itemName
                            };

                            // avoid double-firing if user retries address step
                            window.__mafDonationAddCheckoutSent = window.__mafDonationAddCheckoutSent || {};
                            var dedupeKey = donationType + '|' + donationValue + '|' + itemId;
                            if (!window.__mafDonationAddCheckoutSent[dedupeKey] && typeof window.mafTrackDonationAddToCart === 'function') {
                                window.__mafDonationAddCheckoutSent[dedupeKey] = true;
                                window.mafTrackDonationAddToCart(window.__mafDonationContext);
                            }
                        } catch (e) {
                            // fail silently so donation flow never breaks
                        }
                        // --- [END] GA4 Donation: add_to_cart + begin_checkout (only after SFCC confirms add-to-cart) ---


                        $("#donationAmount").html(resp.subTotals);
                        if(resp.pid == "90001"){
                             $("#donationAmountText").text("Monthly Donation Amount");
                        }
                        $('#payment-container').html(resp.html);
                        $('#csrfToken').val(resp.csrf.token);
                        $('#csrfToken').attr('name', resp.csrf.tokenName);
                        onGooglePayLoaded();

                        // Sync Apple Pay + Google Pay rendering so both appear at the same time.
                        // The DW Apple Pay SDK and Google Pay SDK both initialize asynchronously
                        // after the HTML is injected, causing a flicker where Google Pay appears
                        // first. Hide both until they are both ready, then reveal together.
                        var _apayGpaySupported = window.dw
                            && window.dw.applepay
                            && window.ApplePaySession
                            && window.ApplePaySession.canMakePayments();
                        if (_apayGpaySupported) {
                            $('#applepay-content, #googlepay-content').css('visibility', 'hidden');
                            var _syncInterval = setInterval(function () {
                                var appleReady = $('#applepay-content .dw-apple-pay-button').length > 0;
                                var googleReady = $('#js-googlepay-container').children().length > 0;
                                if (appleReady && googleReady) {
                                    clearInterval(_syncInterval);
                                    clearTimeout(_syncFallback);
                                    $('#applepay-content, #googlepay-content').css('visibility', '');
                                }
                            }, 100);
                            var _syncFallback = setTimeout(function () {
                                clearInterval(_syncInterval);
                                $('#applepay-content, #googlepay-content').css('visibility', '');
                            }, 2500);
                        }

                        $('#donationFormGuestCheckout').addClass("d-none");
                        $(".useraddressContainer").addClass("d-none");
                        $('.dontationPayment-Container').removeClass("d-none");
                        $(".useraddressConfirmContainer").addClass("d-none");                        // Analytics - Step = payment
                        trackDonationStepView('payment');

                        // --- GA4 Donation: begin_checkout when payment step is shown ---
                        try {
                            window.__mafDonationBeginCheckoutSent = window.__mafDonationBeginCheckoutSent || {};
                            var key = (window.__mafDonationContext?.donation_type || '') + '|' + (window.__mafDonationContext?.value || '') + '|' + (window.__mafDonationContext?.item_id || '');
                            if (!window.__mafDonationBeginCheckoutSent[key] && typeof window.mafTrackDonationBeginCheckout === 'function') {
                                window.__mafDonationBeginCheckoutSent[key] = true;
                                window.mafTrackDonationBeginCheckout(window.__mafDonationContext || {});
                            }
                        } catch (e) {}


                    }
                    return;
                }
                if (resp && resp.errors) {
                    if ($.isArray(resp.errors)) {
                        resp.errors.forEach(function (err) {
                            const $field = err.field ? $form.find('[name="' + err.field + '"]') : $();
                            if ($field.length) markInvalid($field, err.message || err.msg || "Invalid value");
                        });
                    } else if (typeof resp.errors === "string") alert(resp.errors);
                    return;
                }
                alert("Unexpected response from server. Check console for details.");
                console.log("GuestDonation-AddToCart response:", resp);
            },
            error: function (jqXhr, textStatus, errorThrown) {
                restoreRemovedNames();
                console.error("AJAX error:", textStatus, errorThrown, jqXhr.responseText);
                try {
                    const parsed = jqXhr.responseJSON || JSON.parse(jqXhr.responseText || "{}");
                    alert(parsed && parsed.message ? parsed.message : "An error occurred while processing the donation.");
                } catch { alert("An error occurred while processing the donation."); }
            },
            complete: function () {
                // re-enable donation inputs so UI remains usable
                restoreRemovedNames();
                $btn.html('')
                $btn.prop("disabled", false).text(origText);
                const $btnUpdate = $("#user-address-update");
                $btnUpdate.html('')
                $btnUpdate.prop("disabled", false).text("Continue");
            }
        });
    });


    // Payment Method Selection Handling

    // --- helpers ---
    function luhnCheck(cardNumber) {
        let sum = 0, alt = false;
        for (let i = cardNumber.length - 1; i >= 0; i--) {
            let n = parseInt(cardNumber.charAt(i), 10);
            if (alt) { n *= 2; if (n > 9) n -= 9; }
            sum += n; alt = !alt;
        }
        return (sum % 10) === 0;
    }

    function detectCardType(num) {
        // 1) If Cleave wrote a card type into #cardType-guestCheckout, use that (normalized)
        try {
            var cleaveType = (typeof jQuery !== "undefined" && jQuery("#cardType-guestCheckout").length) ? (jQuery("#cardType-guestCheckout").val() || "") : "";
            if (cleaveType) {
                cleaveType = String(cleaveType).trim().toLowerCase();
                // normalize common variants Cleave might output (e.g., 'Amex' -> 'amex', 'MasterCard' -> 'mastercard')
                if (cleaveType.indexOf("Amex") !== -1) return "Amex";
                if (cleaveType.indexOf("Visa") !== -1) return "Visa";
                if (cleaveType.indexOf("Master") !== -1) return "Mastercard";
                if (cleaveType.indexOf("Discover") !== -1) return "Discover";
                // if it's something else like 'unknown', fall through to regex below
            }
        } catch (e) {
            // ignore any error reading #cardType-guestCheckout and continue to regex fallback
        }

        // 2) Fallback: use your original regex-based detection against the numeric input
        const n = (num || "").replace(/\s+/g, "");
        if (/^3[47]\d{0,}$/.test(n)) return "Amex";
        if (/^4\d{0,}$/.test(n)) return "Visa";
        if (/^5[1-5]\d{0,}$/.test(n) || /^2(2[2-9]|[3-6]\d|7[01])\d{0,}$/.test(n)) return "Mastercard";
        if (/^6(?:011|5|4[4-9]|22)\d{0,}$/.test(n)) return "Discover";
        return "unknown";
    }

    // --- Safe Cleave init (only if not already initialized) ---
    if (typeof Cleave !== "undefined") {
        (function () {
            try {
                const $cn = $("#Order-CardNumber-guestCheckout");

                // If Cleave already applied, skip
                if ($cn.length && !$cn.data("cleave")) {

                    const cleave = new Cleave("#Order-CardNumber-guestCheckout", {
                        creditCard: true,

                        onCreditCardTypeChanged: function (type) {
                            const creditCardTypes = {
                                Visa: "Visa",
                                MasterCard: "MasterCard",
                                Amex: "Amex",
                                Discover: "Discover",
                                Unknown: "Unknown"
                            };

                            const cardType = creditCardTypes[type] || "Unknown";

                            // Hidden field update
                            if ($("#cardType-guestCheckout").length) {
                                $("#cardType-guestCheckout").val(cardType);
                            } else {
                                $("<input>")
                                    .attr({
                                        type: "hidden",
                                        id: "cardType",
                                        name: "cardType",
                                        value: cardType
                                    })
                                    .appendTo("#donationPaymentFormGuestCheckout");
                            }

                            // Add data attribute so CSS can style
                            $(".card-number-wrapper").attr("data-type", type);

                            // Update CVV length automatically
                            if (type === "Amex") {
                                $("#Order-cvv-GuestCheckout").attr("maxlength", 4);
                            } else {
                                $("#Order-cvv-GuestCheckout").attr("maxlength", 3);
                            }
                        }
                    });

                    // Save instance
                    $cn.data("cleave", cleave);
                }
            } catch (e) {
                console.warn("Cleave init failed (ignored):", e);
            }
        })();
    }


    function formatCardNumberForDisplay(value, cardType) {
        const d = digitsOnly(value);
        if (!d) return "";
        if (cardType === "Amex") {
            return d.replace(/^(\d{1,4})(\d{1,6})?(\d{1,5})?.*$/, function (_, a, b, c) {
                return (a || "") + (b ? " " + b : "") + (c ? " " + c : "");
            }).trim();
        }
        return d.replace(/(.{4})/g, "$1 ").trim();
    }

    // --- DOM refs ---
    const $paymentForm = $("#donationPaymentFormGuestCheckout");
    if (!$paymentForm.length) return console.warn("#donationPaymentFormGuestCheckout not found");
    const $cardNumber = $("#Order-CardNumber-guestCheckout");
    const $cardType = $("#cardType-guestCheckout"); // hidden input
    const $exp = $("#Order-expdate-GuestCheckout");
    const $cvv = $("#Order-cvv-GuestCheckout");
    const $processBtn = $("#donationPaymentBtn");

    // --- live format + detect ---
    $cardNumber.on("input", function () {
        const raw = $(this).val();
        const d = digitsOnly(raw);
        const type = detectCardType(d);
        $(".card-number-wrapper").attr("data-type", type);
        if (type === "Amex") {
            $("#Order-cvv-GuestCheckout").attr("maxlength", 4);
            } else {
            $("#Order-cvv-GuestCheckout").attr("maxlength", 3);
            }
        
        $(this).val(formatCardNumberForDisplay(d, type));
        if ($cardType.length) $cardType.val(type);
        ensureErrorSlot($cardNumber).text("").hide();
        $cardNumber.removeClass("is-invalid");
    });

    // --- validations ---
    function validateCardNumberField() {
        const d = digitsOnly($cardNumber.val());
        if (!d) { markInvalid($cardNumber, "Card number is required."); return { ok: false }; }
        if (d.length < 13 || d.length > 19) { markInvalid($cardNumber, "Enter a valid card number."); return { ok: false }; }
        if (!luhnCheck(d)) { markInvalid($cardNumber, "Invalid card number."); return { ok: false }; }
        const type = detectCardType(d);
        markValid($cardNumber);
        var cardNumber = $cardNumber;
        if (cardNumber.length > 0) {
            $(".type-subheading-image").addClass("d-none");
            $(".card-number-wrapper").removeClass("credit-card-wrapper-container");
        } else {
            $(".type-subheading-image").removeClass("d-none");
            $(".card-number-wrapper").addClass("credit-card-wrapper-container");
        }
        if ($cardType.length) $cardType.val(type);
        return { ok: true, cardType: type, digits: d };
    }
    $cardNumber.on("blur", validateCardNumberField);

    // ---------- format expiry as MM/YY while typing ----------
    $exp.on("input", function (e) {
        const el = this;
        let val = (el.value || "").replace(/\s+/g, "");

        // strip non-digits and non-slash
        val = val.replace(/[^0-9]/g, "");

        // limit to max 4 digits (MMYY)
        if (val.length > 4) val = val.slice(0, 4);

        // build display: MM or MM/YY
        if (val.length <= 2) {
            // if user typed a single digit and it's > '1', prefix a 0 for nicer UX? (we won't auto-prefix here)
            el.value = val;
        } else {
            el.value = val.slice(0, 2) + "/" + val.slice(2);
        }

        // keep caret at the end (simple and safe for this small field)
        try { el.setSelectionRange(el.value.length, el.value.length); } catch (e) { /* ignore */ }

        // clear any existing expiry error while typing
        ensureErrorSlot($exp).text("").hide();
        $exp.removeClass("is-invalid");
    });

    // ---------- improved expiry validation (MM/YY) ----------
    function validateExpiryField() {
        const raw = ($exp.val() || "").trim();
        if (!raw) {
            markInvalid($exp, "Expiration is required.");
            return { ok: false };
        }

        // normalize possible inputs to MM and YY parts:
        // Accepts: "MM/YY", "MMYY", "M/YY", "MYY", "MM / YY", etc.
        let cleaned = raw.replace(/\s+/g, "");           // remove spaces
        cleaned = cleaned.replace(/[^0-9\/]/g, "");      // keep digits and slash only

        let parts = [];
        if (cleaned.indexOf("/") >= 0) {
            parts = cleaned.split("/").filter(Boolean);
        } else if (cleaned.length === 4) {
            parts = [cleaned.slice(0, 2), cleaned.slice(2)];
        } else if (cleaned.length === 3) {
            // e.g. "122" => treat as "12/2" -> "12/02"
            parts = [cleaned.slice(0, 2), cleaned.slice(2)];
        } else if (cleaned.length <= 2) {
            // only month entered
            parts = [cleaned, ""];
        } else {
            // unexpected format
            markInvalid($exp, "Enter expiration in MM/YY format.");
            return { ok: false };
        }

        const mmRaw = (parts[0] || "").padStart(2, "0").slice(0, 2);
        const yyRaw = (parts[1] || "").padStart(2, "0").slice(0, 2);

        const mm = parseInt(mmRaw, 10);
        const yy = parseInt(yyRaw, 10);

        if (!mm || mm < 1 || mm > 12) {
            markInvalid($exp, "Enter a valid month (01-12).");
            return { ok: false };
        }

        // two-digit year -> convert to full year
        const now = new Date();
        const currentFull = now.getFullYear();
        //const currentYY = currentFull % 100;

        let fullYear = (yy < 100) ? (Math.floor(currentFull / 100) * 100 + yy) : yy;

        // Removed next-century adjustment to ensure expired card years (e.g., 24 -> 2024) are validated correctly. [EC-1121]
        // // if two-digit year looks in the past relative to current two-digit, assume next century (rare edge case)
        // if (yy < currentYY) fullYear += 100;

        // expiration is last moment of that month
        const expDate = new Date(fullYear, mm, 0, 23, 59, 59, 999);
        if (expDate.getTime() < Date.now()) {
            markInvalid($exp, "Card has expired.");
            return { ok: false };
        }

        // write a normalized display value (MM/YY) back to the field for consistency
        const display = mmRaw + "/" + yyRaw;
        if ($exp.val() !== display) $exp.val(display);

        markValid($exp);
        return { ok: true, month: mm, year: fullYear };
    }
    $exp.on("blur", validateExpiryField);

    function validateCvvField() {
        const cv = digitsOnly($cvv.val());
        const cardDigits = digitsOnly($cardNumber.val());
        const type = detectCardType(cardDigits);
        const needed = (type === "Amex") ? 4 : 3;
        if (!cv) { markInvalid($cvv, "CVV is required."); return { ok: false }; }
        if (cv.length !== needed) { markInvalid($cvv, "Enter a " + needed + "-digit CVV."); return { ok: false }; }
        markValid($cvv);
        return { ok: true };
    }
    $cvv.on("input", function (e) {
        validateCvvField();
    })
    $cvv.on("blur", validateCvvField);

    // --- final click: process payment (payment-only) ---
    $processBtn.on("click", function (e) {
        $("#maf-close-donation").addClass("d-none")
        e.preventDefault();
        const $btn = $(this);

        const cardOk = validateCardNumberField().ok;
        const expOk = validateExpiryField().ok;
        const cvvOk = validateCvvField().ok;

        if (!(cardOk && expOk && cvvOk)) {
            const $firstInvalid = $(".is-invalid").first();
            if ($firstInvalid.length) $firstInvalid.focus();
            return;
        }

        // prepare payload (only payment form)
        // set cardType hidden if present
        if ($cardType.length) $cardType.val(detectCardType(digitsOnly($cardNumber.val())));

        const data = $paymentForm.serialize();

        const endpoint = baseUrl + "/on/demandware.store/Sites-medicalert-Site/default/Checkout-SubmitOrderGuestCheckout"; // adjust as needed
        const origText = $btn.text();
        const loaderURL = $('#loaderImage').val();

        $btn.prop('disabled', true).html(`
        <span class="loaderForWizard">
            <img class="loaderForWizardImage" src="${loaderURL}" alt="credit-card-image" />
        </span>
        `);

        $.ajax({
            url: endpoint,
            method: "POST",
            data: data,
            dataType: "json",
            success: function (data) {
                if (data && data.success) {

                    // --- [START] GA4 Donation: purchase (server-confirmed + transaction_id) ---
                    try {
                        var orderId = String(data.orderID || '');
                        var ctx = window.__mafDonationContext || {};

                        // Determine donation type from returned order item name (you already use this logic below)
                        var productName = data.order?.items?.items?.[0]?.productName || '';
                        var donationType = (productName === 'Recurring Donation') ? 'monthly' : 'one_time';

                        // Prefer SFCC-confirmed amount if present, else fall back to context from add_to_cart step
                        var amount = data?.order?.billing?.payment?.selectedPaymentInstruments?.[0]?.amount;
                        var donationValue = Number(amount || ctx.value || 0);

                        var itemName = ctx.item_name || ((donationType === 'monthly' ? 'Monthly' : 'One-Time') + ' Donation');
                        var itemId = ctx.item_id || $('#donationPid').val() || 'DONATION';

                        if (typeof window.mafTrackDonationPurchase === 'function') {
                            window.mafTrackDonationPurchase({
                                transaction_id: orderId,
                                currency: 'USD',
                                donation_type: donationType,
                                value: donationValue,
                                item_id: itemId,
                                item_name: itemName
                            });
                        }
                    } catch (e) {
                        // fail silently so donation flow never breaks
                    }
                    // --- [END] GA4 Donation: purchase (server-confirmed + transaction_id) ---


                    callOrderConfirmationPage(data.orderID,data.token);
                    $('.dontationPayment-Container').addClass("d-none");
                    $('#donationFormGuestCheckout').addClass("d-none");
                    $('.donationConfirmation-Container').removeClass("d-none");
                    // Analytics - Step = confirmation
                    trackDonationStepView('confirmation');
                    $("#maf-close-donation").removeClass("d-none")

					// ---------- Donation Type ----------
					if (data.order?.items?.items?.[0]?.productName=== "Recurring Donation") {
						$('#donation-confirmation-type').text("Recurring");
                        // for print
						$('#donation-confirmation-type-print').text("Recurring");

					} else if (data.order?.items?.items?.[0]?.productName=== "Donation") {
						$('#donation-confirmation-type').text("One Time");
                        // for print
						$('#donation-confirmation-type-print').text("One Time");

					}

                    let orderNumber = data.orderID || '';
                    $('#donation-order-number').text(`${orderNumber}`);
					
                    // success behaviour — replace with your UI/toast flow if you have it
                    var amount = data.order.billing.payment.selectedPaymentInstruments[0].amount || '';
					const formattedAmount = new Intl.NumberFormat('en-US', {
						style: 'currency',
						currency: 'USD'
					}).format(amount);

                    $('#donation-confirmation-amount').text(formattedAmount);
					$('#donation-confirmation-amount-total').text(formattedAmount);

                    // ---------- Email ----------
                    $('#Confirmation-user-email').text(
                        data.order?.orderEmail ? `${data.order.orderEmail}` : ''
					);
					
					$('#Confirmation-user-phn').text(
						data.order?.billing?.billingAddress?.address?.phone ? `${data.order?.billing?.billingAddress?.address?.phone}` : ''
					);

					$('#Confirmation-user-memberId').text(
						data.memberId ? `Member ID: ${data.memberId}` : ''
					);

                    // ---------- Name ----------
                    let addr = data.order?.billing?.billingAddress?.address;
                    let fullName = addr
                        ? `${addr.firstName || ''} ${addr.lastName || ''}`.trim()
						: '';
					let firstName = addr
						? addr.firstName.trim()
						: '';

					$('#Confirmation-user-Name').text(firstName ? `${firstName}` : '');
					$('#Confirmation-user-Name2').text(fullName ? `${fullName}` : '');

                    // ---------- Product Type (NEW) ----------
                    let productType = data.order.items.items?.[0]?.productType || '';

                    $('#Confirmation-product-type').text(
                        productType ? `Product Type: ${productType}` : ''
                    );

                    // ---------- Payment Method ----------
                    let paymentInstrument =
                        data.order?.billing?.payment?.selectedPaymentInstruments?.[0];

                    let paymentMethod = data.order.billing.payment.selectedPaymentInstruments[0].type || '';

                    let cardDisplay =
                        data.cardDisplay || paymentInstrument?.maskedCreditCardNumber || '';

					let paymentText = paymentMethod;
                    let cardExpMonth = paymentInstrument?.expirationMonth || '';
                    let cardExpYear = paymentInstrument?.expirationYear || '';

					if (paymentMethod) {
						const targetId = `payment-method-${paymentMethod.toLowerCase()}`;
						const el = document.getElementById(targetId);
						if (el) {
                            $('#payment-method-visa,#payment-method-mastercard,#payment-method-amex,#payment-method-discover').addClass("d-none");
							el.classList.remove("d-none");
						}
					}

					if (cardDisplay) {
						paymentText = cardDisplay + ' - ' + cardExpMonth + '/' + cardExpYear;
					}

                    $('#Payment-method-used').text(paymentText);
                    $('#Payment-method-used2').text(paymentText);
                    
                    // For print donation confirmation
                    
                    $('#invoice-number-print').text(`${orderNumber}`);
                    if(data.memberId==null){
                        $("#memberIdPrintContainer").addClass('d-none');
                    }
                    else{
                         $("#memberIdPrintContainer").removeClass('d-none');
                        $('#member-id-print').text(`${data.memberId}`);

                    }

                    if (paymentMethod) {
						const targetId = `payment-method-${paymentMethod.toLowerCase()}-print`;
						const el = document.getElementById(targetId);
						if (el) {
                            $('#payment-method-visa-print, #payment-method-mastercard-print, #payment-method-amex-print, #payment-method-discover-print').addClass("d-none");
							el.classList.remove("d-none");
						}
					}
                    $('#Payment-method-used-print').text(paymentText);
					$('#donation-confirmation-amount-total-print').text(formattedAmount);
					$('#donation-confirmation-amount-total-print2').text(formattedAmount);
					$('#donation-confirmation-amount-total-print3').text(formattedAmount);
					$('#donation-confirmation-amount-total-print4').text(formattedAmount);

                    // For print donation confirmation - Billing address
                    const lastName    = addr?.lastName?.trim() || '';
                    const address1    = addr?.address1?.trim() || '';
                    const address2    = addr?.address2?.trim() || '';
                    const city        = addr?.city?.trim() || '';
                    const stateCode   = addr?.stateCode?.trim() || '';
                    const countryName = addr?.countryCode?.displayValue?.trim() || '';
                    const postalCode  = addr?.postalCode?.trim() || '';
                    const phone       = addr?.phone?.trim() || '';
                    
                    $('#first-name-print').text(firstName);
                    $('#last-name-print').text(lastName);
                    $('#address1-print').text(address1);
                    $('#city-print').text(city + ',');
                    $('#state-print').text(stateCode + ',');
                    $('#country-print').text(countryName + ',');
                    $('#postalcode-print').text(postalCode);
                    $('#phone-print').text(phone);

                    return;
                }
                if (data && data.errors) {
                    $("#maf-close-donation").removeClass("d-none")
                    if ($.isArray(resp.errors)) {
                        resp.errors.forEach(function (err) {
                            if (err.field) {
                                const $f = $paymentForm.find('[name="' + err.field + '"]');
                                if ($f.length) markInvalid($f, err.message || err.msg || "Invalid value");
                            }
                        });
                    } else if (typeof resp.errors === "string") alert(resp.errors);
                    return;
                }
                alert("Unexpected response from payment server. See console.");
                console.log("Payment resp:", resp);
            },
            error: function (xhr) {
                $("#maf-close-donation").removeClass("d-none")
                console.error("Payment AJAX error", xhr.status, xhr.responseText);
                try {
                    const parsed = xhr.responseJSON || JSON.parse(xhr.responseText || "{}");
                    alert(parsed.message || "Payment failed. Try again.");
                } catch (ex) {
                    alert("Payment failed. Try again.");
                }
            },
            complete: function () {
                $("#maf-close-donation").removeClass("d-none")
                $btn.prop("disabled", false).text(origText);
            }
        });
    })

    // To Sync the Order To CRM

   function callOrderConfirmationPage(orderID, orderToken) {
    var endpoint = baseUrl + "/on/demandware.store/Sites-medicalert-Site/default/Order-Confirm";

    var queryParams = $.param({
        orderID: orderID,
        token: orderToken
    });
    $.ajax({
        url: endpoint + '?' + queryParams,
        method: "GET",
        dataType: "json",
        success: function (data) {
          console.log(data);
        },
        error: function (err) {
            console.error("Error:", err);
        }
        });
    }

    // $('#donationCloseBtn').on('click', function () {
    //     //Track closes from the confirmation “Close” button
    //     trackDonationModalClose('close_button_confirmation');
        
    //     hideGuestCheckoutModal();
    //     window.location.href = "https://www.medicalert.org/";
    // });

    $('#donationCloseBtn').on('click', function () {
        trackDonationModalClose('close_button_confirmation');
        hideGuestCheckoutModal();

        var returnUrl = sessionStorage.getItem('donationReturnUrl');
        if (returnUrl) {
            sessionStorage.removeItem('donationReturnUrl');
            window.location.href = returnUrl;
        } else {
            window.location.href = "https://www.medicalert.org/";
        }
    });

    // --- Expose donation analytics helpers globally (used by showGuestCheckoutModal) ---
    window.resetDonationModalSession = resetDonationModalSession;
    window.trackDonationStepView = trackDonationStepView;
    window.trackDonationModalClose = trackDonationModalClose;

});




function hideGuestCheckoutModal() {
    $('#guestCheckoutDonationModal').hide();
    $('body').removeClass('guest-checkout-donation-modal-visible');
}

function showGuestCheckoutModal() {
    $('#guestCheckoutDonationModal').show();
    $('body').addClass('guest-checkout-donation-modal-visible');

    // Analytics - Reset session (safe)
    if (typeof window.resetDonationModalSession === 'function') {
        window.resetDonationModalSession();
    }

    // Analytics - Step = amount (modal opened)
    if (typeof window.trackDonationStepView === 'function') {
        window.trackDonationStepView('amount');
    }
}


function updateMiniCart(data) {
    var cartItems = data.cartItems.length;
    insertNumberCartItems(cartItems);
}

function callAjaxCartProductLine() {
    var url = baseUrl + "/on/demandware.store/Sites-medicalert-Site/en_US/Cart-CheckProductLineItem";
    $.ajax({
        url: url,
        type: 'GET',
        async: true,
        jsonpCallback: 'jsonCallback',
        contentType: "application/json",
        dataType: 'jsonp',
        success: function (data) {
            updateMiniCart(data);
        }
    });
}






callAjaxCartProductLine();

// Apple Pay donation loader — mirrors Google Pay's showModalTransactionInProgress.
// 'prepareBasket' fires when the Apple Pay sheet opens; 'Cancelled' fires when dismissed.
document.addEventListener('prepareBasket', function () {
    var $btn = $('#donationPaymentBtn');
    if (!$btn.length) return;
    var loaderURL = $('#loaderImage').val();
    $btn.prop('disabled', true).html(
        '<span class="loaderForWizard">' +
        '<img class="loaderForWizardImage" src="' + loaderURL + '" alt="loading" />' +
        '</span>'
    );
});

document.addEventListener('Cancelled', function () {
    var $btn = $('#donationPaymentBtn');
    if (!$btn.length) return;
    $btn.prop('disabled', false).text('Donate');
});
